import React from 'react';
import { TextareaAutosize } from '@mui/material';

export default function MyTextAreaAutoSize(props) {
    return (
        <TextareaAutosize {...props} />
    );
}